var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSync = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5688 3.12565C12.0882 3.12565 13.5273 3.62218 14.7167 4.52586L11.9637 7.11773L18.9662 7.86864L18.637 0.833984L15.845 3.46329C14.3554 2.25635 12.5129 1.59787 10.5688 1.59787C5.93581 1.59787 2.16602 5.36766 2.16602 10.0007H3.69379C3.69379 6.20947 6.77761 3.12565 10.5688 3.12565Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5693 16.875C9.04993 16.875 7.61076 16.3785 6.42139 15.4748L9.17444 12.8829L2.17188 12.132L2.50111 19.1667L5.29312 16.5374C6.78271 17.7443 8.62521 18.4028 10.5693 18.4028C15.2023 18.4028 18.9721 14.633 18.9721 10H17.4443C17.4443 13.7912 14.3605 16.875 10.5693 16.875Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSync, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sync.008838ec.svg";
export { ForwardRef as ReactComponent };